export const formatPrice = (price) => price?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })

export const calcDiscountedPrice = (promotion, fullPrice) => {
  const discount = promotion ? promotion.discountValue : 0
  return promotion?.discountType === 'PERCENTAGE' ? (1 - (discount / 100)) * fullPrice : fullPrice - discount
}

export const calculateTotalPrice = (pricesData, isServicePackage, additionalServices) => {
  if (isServicePackage) {
    const mainService = pricesData.find(price => price.additional === false)
    let totalPrice = mainService?.price || 0

    for (const additional of additionalServices || []) {
      const additionalService = pricesData.find(price => price.id === additional.id)
      if (additionalService) {
        const quantity = additional.quantity || 1
        const packageDiscount = mainService?.packageDiscount || 0
        const discountedPrice = additionalService.price - (additionalService.price * (packageDiscount / 100))

        totalPrice += discountedPrice * quantity
      }
    }

    return totalPrice
  }

  return pricesData.reduce((acc, curr) => acc + curr.price, 0)
}
